import { useEffect } from 'react';

/** Prevent indexing of authenticated, private, or utility pages (meta tag; see also _headers). */
export function useNoIndexPage() {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    const created = !meta;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'robots';
      document.head.appendChild(meta);
    }
    const previous = meta.content;
    meta.content = 'noindex, nofollow, noarchive';

    return () => {
      if (created && meta?.parentNode) meta.parentNode.removeChild(meta);
      else if (meta) meta.content = previous;
    };
  }, []);
}
